import { BadgeVariant } from '../models';

export enum ShiftStatusEnum {
  Posted = 'Posted',
  Pending = 'Pending',
  PartiallyFilled = 'PartiallyFilled',
  InProgress = 'InProgress',
  Confirmed = 'Confirmed',
  Completed = 'Completed',
  Cancelled = 'Cancelled',
  NoShow = 'NoShow',
  Expired = 'Expired'
}

export const SHIFT_STATUS_RECORD: Record<ShiftStatusEnum, string> = {
  [ShiftStatusEnum.Posted]: 'Posted',
  [ShiftStatusEnum.Pending]: 'Pending',
  [ShiftStatusEnum.PartiallyFilled]: 'Partially Filled',
  [ShiftStatusEnum.InProgress]: 'In Progress',
  [ShiftStatusEnum.Confirmed]: 'Confirmed',
  [ShiftStatusEnum.Completed]: 'Completed',
  [ShiftStatusEnum.Cancelled]: 'Cancelled',
  [ShiftStatusEnum.NoShow]: 'No Show',
  [ShiftStatusEnum.Expired]: 'Expired'
};

export const SHIFT_STATUS_BADGE_PROPS: Record<
  ShiftStatusEnum,
  { label: string; iconName?: string; variant: BadgeVariant; outlined: boolean }
> = {
  [ShiftStatusEnum.Posted]: {
    label: SHIFT_STATUS_RECORD[ShiftStatusEnum.Posted],
    iconName: 'phosphorBookOpenBold',
    variant: 'primary',
    outlined: true
  },
  [ShiftStatusEnum.Pending]: {
    label: SHIFT_STATUS_RECORD[ShiftStatusEnum.Pending],
    iconName: 'phosphorHourglassBold',
    variant: 'primary',
    outlined: true
  },
  [ShiftStatusEnum.PartiallyFilled]: {
    label: SHIFT_STATUS_RECORD[ShiftStatusEnum.PartiallyFilled],
    iconName: 'phosphorDotsThreeCircle',
    variant: 'warning',
    outlined: true
  },
  [ShiftStatusEnum.InProgress]: {
    label: SHIFT_STATUS_RECORD[ShiftStatusEnum.InProgress],
    iconName: 'phosphorPlayCircleBold',
    variant: 'secondary',
    outlined: true
  },
  [ShiftStatusEnum.Confirmed]: {
    label: SHIFT_STATUS_RECORD[ShiftStatusEnum.Confirmed],
    iconName: 'phosphorCheckCircleBold',
    variant: 'info',
    outlined: true
  },
  [ShiftStatusEnum.Completed]: {
    label: SHIFT_STATUS_RECORD[ShiftStatusEnum.Completed],
    iconName: 'phosphorChecksBold',
    variant: 'success',
    outlined: true
  },
  [ShiftStatusEnum.Cancelled]: {
    label: SHIFT_STATUS_RECORD[ShiftStatusEnum.Cancelled],
    iconName: 'phosphorXCircleBold',
    variant: 'error',
    outlined: true
  },
  [ShiftStatusEnum.NoShow]: {
    label: SHIFT_STATUS_RECORD[ShiftStatusEnum.NoShow],
    iconName: 'phosphorProhibitBold',
    variant: 'error',
    outlined: true
  },
  [ShiftStatusEnum.Expired]: {
    label: SHIFT_STATUS_RECORD[ShiftStatusEnum.Expired],
    iconName: 'phosphorClockAfternoon',
    variant: 'neutral',
    outlined: true
  }
};
